import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ArrowLeft } from 'lucide-react';

const TermosCondicoesPage = () => {
  return (
    <>
      <Helmet>
        <title>Termos e Condições | Seminário Psicoteológico Kairós</title>
        <meta name="description" content="Termos e condições de uso do site e regras gerais do evento Kairós." />
      </Helmet>

      <div className="min-h-screen bg-obsidian" data-testid="termos-page">
        {/* Navigation */}
        <nav className="fixed top-0 left-0 right-0 z-50 bg-obsidian/90 backdrop-blur-md border-b border-white/5">
          <div className="container mx-auto px-4 h-16 flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <ArrowLeft className="w-5 h-5 text-gray-400" />
              <img src="/logo-kairos.png" alt="Kairós" className="w-10 h-10 rounded-full object-cover" />
              <span className="font-display text-xl text-white">Kairós</span>
            </Link>
          </div>
        </nav>

        {/* Content */}
        <main className="pt-24 pb-20">
          <div className="container mx-auto px-4 max-w-4xl">
            <article className="prose prose-invert prose-lg max-w-none">
              <p className="text-gray-400 text-sm mb-2">Última atualização: 01 de março de 2026</p>
              
              <h1 className="font-display text-3xl md:text-4xl text-white mb-8">
                Termos e Condições – Site Kairós
              </h1>

              <section className="mb-10">
                <h2 className="text-xl md:text-2xl text-white font-semibold mb-4">1. Aceitação dos Termos</h2>
                <p className="text-gray-300 leading-relaxed">
                  Ao acessar e utilizar o site oficial do Seminário Psicoteológico Kairós, o usuário declara ter lido, compreendido e concordado com os presentes Termos e Condições de Uso.
                </p>
                <p className="text-gray-300 leading-relaxed">
                  Caso não concorde com qualquer disposição aqui prevista, recomenda-se que não utilize este site.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl md:text-2xl text-white font-semibold mb-4">2. Finalidade do Site</h2>
                <p className="text-gray-300 leading-relaxed mb-4">O site tem como objetivo:</p>
                <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                  <li>Divulgar informações sobre o 2º Encontro de Casais – Seminário Psicoteológico Kairós;</li>
                  <li>Permitir inscrições;</li>
                  <li>Disponibilizar informações sobre programação, palestrantes e hospedagem;</li>
                  <li>Viabilizar comunicação com os participantes.</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-xl md:text-2xl text-white font-semibold mb-4">3. Inscrição e Pagamento</h2>
                <p className="text-gray-300 leading-relaxed mb-4">A inscrição somente será considerada válida após:</p>
                <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                  <li>Preenchimento completo da ficha;</li>
                  <li>Aceite do Termo de Compromisso e Inscrição;</li>
                  <li>Confirmação do pagamento.</li>
                </ul>
                <p className="text-gray-300 leading-relaxed mt-4">
                  O organizador se reserva o direito de cancelar inscrições com informações inconsistentes ou pagamentos não confirmados.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl md:text-2xl text-white font-semibold mb-4">4. Alterações na Programação</h2>
                <p className="text-gray-300 leading-relaxed mb-4">
                  O organizador poderá, por motivo de força maior, necessidade técnica ou logística:
                </p>
                <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                  <li>Alterar palestrantes;</li>
                  <li>Ajustar cronogramas;</li>
                  <li>Realizar mudanças estruturais necessárias ao bom andamento do evento.</li>
                </ul>
                <p className="text-gray-300 leading-relaxed mt-4">
                  Tais alterações não caracterizam descumprimento contratual.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl md:text-2xl text-white font-semibold mb-4">5. Limitação de Responsabilidade</h2>
                <p className="text-gray-300 leading-relaxed mb-4">O organizador não se responsabiliza por:</p>
                <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                  <li>Problemas de conexão à internet;</li>
                  <li>Falhas no sistema bancário ou operadoras de cartão;</li>
                  <li>Informações prestadas incorretamente pelo participante.</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-xl md:text-2xl text-white font-semibold mb-4">6. Propriedade Intelectual</h2>
                <p className="text-gray-300 leading-relaxed">
                  Todo o conteúdo do site, incluindo textos, imagens, logotipos e identidade visual, é protegido por direitos autorais e não pode ser reproduzido sem autorização prévia.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-xl md:text-2xl text-white font-semibold mb-4">7. Foro</h2>
                <p className="text-gray-300 leading-relaxed">
                  Fica eleito o foro da comarca competente do organizador para dirimir quaisquer controvérsias decorrentes da utilização do site.
                </p>
              </section>
            </article>

            {/* Back link */}
            <div className="mt-12 pt-8 border-t border-white/10">
              <Link to="/" className="inline-flex items-center gap-2 text-kairos-orange hover:text-kairos-orange-light transition-colors">
                <ArrowLeft className="w-4 h-4" />
                Voltar para o início
              </Link>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="py-8 border-t border-white/5">
          <div className="container mx-auto px-4 text-center">
            <p className="text-gray-500 text-sm">
              © 2026 Seminário Psicoteológico Kairós. Todos os direitos reservados.
            </p>
          </div>
        </footer>
      </div>
    </>
  );
};

export default TermosCondicoesPage;
